// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"DropdownLink_pattern-gradient__rubqg","link":"DropdownLink_link__WcEYG"};